import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  props: {
    data: {
      type: Object,
      required: false,
      default: function _default() {}
    },
    topIcon: {
      type: Object,
      required: false,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var topBarIconLink = computed(function () {
      var _props$topIcon;
      return props === null || props === void 0 ? void 0 : (_props$topIcon = props.topIcon) === null || _props$topIcon === void 0 ? void 0 : _props$topIcon.url;
    });
    var _useUiState = useUiState(),
      isLanguageModalOpen = _useUiState.isLanguageModalOpen;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers;

    /**
     * Tracks a top bar banner click event in GTM.
     *
     * @function clickTopBarEvent
     * @property {string} [props.data.url] - Target page URL.
     * @property {string} [props.data.topText] - Banner label text.
     */
    function clickTopBarEvent() {
      var _props$data, _props$data2;
      $trackers.gtm.pushEvent('click_header_banner', {
        page_target: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.url,
        event_label: (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.topText
      });
    }

    /**
     * Watches for changes in the route's full path and tracks a "view_header_banner" event in GTM.
     *
     * @watch
     * @param {string} route.fullPath - The current route's full path.
     * @param {string} [props.data.url] - The target page URL for the header banner.
     * @description If the current route's path changes and differs from the banner's URL,
     *              a GTM event is triggered to indicate the banner was viewed.
     */

    watch(function () {
      return route.fullPath;
    }, function (newVal) {
      var _props$data3;
      if (newVal !== ((_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.url)) {
        var _props$data4;
        $trackers.gtm.pushEvent('view_header_banner', {
          page_target: (_props$data4 = props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.url
        });
      }
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      route: route,
      props: props,
      topBarIconLink: topBarIconLink,
      isLanguageModalOpen: isLanguageModalOpen,
      $trackers: $trackers,
      clickTopBarEvent: clickTopBarEvent,
      AzButton: AzButton,
      AzImg: AzImg
    };
  }
});